module.exports = __webpack_public_path__ + "img/calendar_icn.6acece28.svg";